module.exports = __webpack_public_path__ + "img/播放视频@2x.82589e0e.png";